import { render } from "./ProfileContacts.vue?vue&type=template&id=66aa9516&scoped=true"
import script from "./ProfileContacts.vue?vue&type=script&lang=js"
export * from "./ProfileContacts.vue?vue&type=script&lang=js"

import "./ProfileContacts.vue?vue&type=style&index=0&id=66aa9516&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66aa9516"]])

export default __exports__